



















































































import { Component, Vue } from 'vue-property-decorator'
import EditUserDialog from './EditUserDialog.vue'
import DeleteUserDialog from './DeleteUserDialog.vue'
import GMap from '@/components/GMap.vue'
import Roles from '@/components/Roles.vue'
import { Managers, userIs, currentUserIs, UserRole } from '@/types/Users'
import { loadUser } from '@/services/users'
import ClipboardCopy from '@/components/ClipboardCopy.vue'

@Component({
  components: {
    EditUserDialog,
    DeleteUserDialog,
    Roles,
		ClipboardCopy,
		GMap,
  },
})
export default class User extends Vue {
  selectedUser: User | null = null
  editUserDialog = false
  deleteUserDialog = false
  loading = false

  metaInfo() {
    return {
      title: this.user ? this.$options.filters?.fullName(this.user) : 'User',
    }
  }

  async mounted() {
		await loadUser(this.$store, parseInt(this.$route.params.userId))
	}

  get user() {
    return this.$store.getters.user(this.$route.params.userId)
  }

  get me() {
    return this.$store.getters.me
  }

	get manager() {
		if (this.user.manager_id) {
			return this.$store.getters.user(this.user.manager_id)
		}
		return null
	}

	get currentUserIsAdmin() {
		return currentUserIs(UserRole.Admin)
	}

	get currentUserIsManager() {
		return currentUserIs(...Managers)
	}

	get userIsContractor() {
		return userIs(this.user, UserRole.Contractor)
	}
}
